<template>
    <div class="content_div">
        <el-card>
            <el-form :inline="true" :model="query" class="demo-form-inline" STYLE="margin-bottom: 20px;">
                <el-form-item label="商家名称">
                    <el-input clearable class="input_class" v-model="query.name" auto-complete="off" placeholder="请输入商家名称"></el-input>
                </el-form-item>
                <el-form-item label="联系人姓名">
                    <el-input clearable class="input_class" v-model="query.contactName" auto-complete="off" placeholder="请输入联系人姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系人电话">
                    <el-input clearable class="input_class" v-model="query.contactPhone" auto-complete="off"
                              placeholder="请输入联系人电话"></el-input>
                </el-form-item>
                <!--                <el-form-item label="上架状态" clearable>-->
                <!--                    <el-select v-model="query.state" placeholder="请选择上架状态">-->
                <!--                        <el-option label="全部" value=""></el-option>-->
                <!--                        <el-option label="上架" value="0"></el-option>-->
                <!--                        <el-option label="下架" value="1"></el-option>-->
                <!--                    </el-select>-->
                <!--                </el-form-item>-->
                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
                <el-button type="success" @click="btnInsert(null,0)">新增</el-button>
            </el-form>
            <el-table
                :data="dataList"
                border>
                <el-table-column type="index" label="编号" width="80"/>
                <el-table-column prop="name" label="商家名称"/>
                <el-table-column prop="contactName" label="联系人姓名"/>
                <el-table-column prop="contactPhone" label="联系人电话"/>
                <el-table-column prop="creditCode" label="社会信用代码"/>
                <el-table-column prop="address" label="地址"/>
                <el-table-column prop="createTime" label="创建时间"/>
                <el-table-column align="center" label="操作" width="210">
                    <template slot-scope="scope">
                        <el-button size="small" type="info" @click="btnInsert(scope.row,2)">修改</el-button>
                        <el-button size="small" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top:10px;"
                           background
                           layout="total,prev, pager, next"
                           @current-change="currentChange"
                           :total="total">
            </el-pagination>
        </el-card>


        <el-dialog :close-on-click-modal="false" title="操作" :visible="isShowDialogFlag" @close="close(0)" width="30%">
            <el-form label-width="150px" :model="data" ref="data" :rules="rules">
                <el-form-item label="商家名称" prop="name">
                    <el-input class="input_class" v-model="data.name" maxlength="20" auto-complete="off" placeholder="请输入商家名称"></el-input>
                </el-form-item>
                <el-form-item label="联系人姓名" prop="contactName">
                    <el-input class="input_class" v-model="data.contactName" maxlength="20" auto-complete="off"
                              placeholder="请输入联系人姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系人电话" prop="contactPhone">
                    <el-input class="input_class" v-model="data.contactPhone" maxlength="11" auto-complete="off"
                              placeholder="请输入联系人电话"></el-input>
                </el-form-item>
                <el-form-item label="社会信用代码" prop="creditCode">
                    <el-input class="input_class" v-model="data.creditCode" maxlength="30" auto-complete="off"
                              placeholder="请输入社会信用代码"></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input class="input_class" v-model="data.address" maxlength="50" auto-complete="off" placeholder="请输入地址"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding-right: 10%;">
                <el-button @click='close'>取消</el-button>
                <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {reqDeleteMerChantById, reqInsertMerChant, reqListMerChant, reqUpdateMerChant} from "../../../api/core/Merchant";

export default {
    name: "SysDict",
    created() {
        this.load();
    },
    methods: {
        async load() {
            this.dataList = [];
            let result = await reqListMerChant(this.query);
            this.dataList = result.records;
            this.total = result.total;
        },
        async reset() {
            this.query = {currentPage: 1};
            await this.load();
        },
        currentChange(num) {
            this.query.currentPage = num;
            this.load();
        },
        async btnDelete(id) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqDeleteMerChantById({id: id});
                this.$message.success("操作成功");
                this.query.current = 1
                await this.load();
            });
        },
        async submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.data.type = 1;
                    let result = this.data.id !== null ? await reqUpdateMerChant(this.data) : await reqInsertMerChant(this.data);
                    await this.close();
                    await this.load();
                    this.$message.success("操作成功");
                } else {
                    return false;
                }
            });
        },
        btnInsert(row, type) {
            if (type === 0) {
                this.data = {id: null, pid: null, name: null, sort: 1};
            } else if (type === 1) {
                this.data = {id: null, pid: row.id, name: null, sort: 1};
            } else {
                this.data = JSON.parse(JSON.stringify(row));
            }
            this.isShowDialogFlag = true;
        },
        async close() {
            this.isShowDialogFlag = false;
        }
    },
    data() {
        return {
            total: 0,
            dataList: [],
            query: {
                currentPage: 1,
                pageSize: 10,
                name: null,
                contactName: null,
                contactPhone: null,
            },
            isShowDialogFlag: false,
            data: {
                id: null,
                name: null,
                contactName: null,
                contactPhone: null,
                creditCode: null,
            },
            rules: {
                name: [
                    {required: true, message: '请输入商户名称', trigger: 'blur'}
                ],
                contactName: [
                    {required: true, message: '请输入联系人', trigger: 'blur'}
                ],
                contactPhone: [
                    {required: true, message: '请输入联系电话', trigger: 'blur'}
                ],
                creditCode: [
                    {required: true, message: '请输入统一社会信用代码', trigger: 'blur'}
                ],
                address: [
                    {required: true, message: '请输入地址', trigger: 'blur'}
                ]
            },
        }
    },
}
</script>
<style scoped>
.input_class {
    width: 80%;
}
</style>
